import {Component, Input, OnChanges, OnInit, SimpleChanges, TemplateRef} from '@angular/core';
import {SysDataModelFieldService} from "../../../services/system/sys-data-model-field.service";
import {TagService} from "../../../services/tag/tag.service";
import {BasicEntityService} from "../../../services/data/basic-entity.service";

@Component({
  selector: 'pi-resource-detail-viewer',
  templateUrl: './pi-resource-detail-viewer.component.html',
  styleUrls: ['./pi-resource-detail-viewer.component.css']
})
export class PiResourceDetailViewerComponent implements OnInit, OnChanges {
  @Input() dataModelId: any;
  @Input() requestUrlBase: string;
  @Input() dataId: any;
  @Input() columnSettings: any = { xxl: 4, xl: 4, lg: 4, md: 4, sm: 4, xs: 3 };
  @Input() contentTemplate: TemplateRef<any>;
  fields: any[];
  visibleFields: any[];
  data: any;
  tagMap: any = {};
  isLoading = false;

  constructor(
    private sysDataModelFieldService: SysDataModelFieldService,
    private tagService: TagService,
    private basicEntityService: BasicEntityService
  ) { }

  ngOnInit(): void {
    this.loadTagData();
  }

  loadTagData() {
    this.tagService.searchData({}, true, 10000).subscribe(res => {
      this.tagMap = {};
      res.forEach(tag => {
        this.tagMap[tag.id] = tag.tagName;
      })
    })
  }

  async ngOnChanges(changes: SimpleChanges) {
    if (this.dataModelId && this.requestUrlBase && this.dataId) {
      this.loadData();
    }
  }

  async loadData() {
    this.isLoading = true;
    try {
      const result = await this.sysDataModelFieldService.getById(this.dataModelId).toPromise();
      const result2 = await this.basicEntityService.searchById(this.requestUrlBase, this.dataId).toPromise();
      this.isLoading = false;
      if (result2 && result2.length > 0) {
        this.data = result2[0];
      }
      this.fields = result;
      this.visibleFields = this.fields.filter(f => f.isDisplayField).sort((a, b) => a.displayOrder - b.displayOrder);
    } catch (e) {
      this.isLoading = false;
      console.error(e);
    }
  }

  stringEqual(a: string, b: string) {
    if (a && b) {
      return a.toLowerCase() === b.toLowerCase();
    } else {
      return a === b
    }
  }
}
